import * as React from "react";
import { toast } from "react-toastify";
import { Icon } from "@grandvisionhq/icons";
const TOAST_INFO = "TOAST/info";
const TOAST_SUCCESS = "TOAST/success";
const TOAST_FAILED = "TOAST/failed";
const TOAST_WARNING = "TOAST/warning";
const buildContent = (name, label) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { className: "Toastify__toast-icon", name }), /* @__PURE__ */ React.createElement("span", { className: "Toastify__toast-label" }, label));
};
const toastService = () => {
  let getLabel;
  const showToast = (type) => (labelKey) => {
    const label = getLabel ? getLabel(labelKey) : "";
    switch (type) {
      case TOAST_INFO:
        toast.info(buildContent("information-circle", label));
        break;
      case TOAST_SUCCESS:
        toast.success(buildContent("checkmark-circle", label));
        break;
      case TOAST_FAILED:
        toast.error(buildContent("alert-circle", label));
        break;
      case TOAST_WARNING:
        toast.warn(buildContent("warning", label));
        break;
    }
  };
  const init = (getter) => {
    getLabel = getter;
  };
  return {
    init,
    info: showToast(TOAST_INFO),
    success: showToast(TOAST_SUCCESS),
    failed: showToast(TOAST_FAILED),
    warning: showToast(TOAST_WARNING)
  };
};
const toastService$1 = toastService();
export {
  buildContent,
  toastService$1 as default
};
//# sourceMappingURL=ToastService.js.map
